import { observable, action, computed } from 'mobx';
import { ICartSidebarServiceConfig } from '~domain/entities/Config/IConfig';

// TODO: revisit when we have more details on how Vulcan will pass in tenant details
export default class Config {
    @observable public config: ICartSidebarServiceConfig;

    @action
    public updateConfig(config: ICartSidebarServiceConfig) {
        this.config = {
            ...this.config,
            ...config,
            ...config.cartConfig,
            businessUnitId:
                config?.businessUnitId ||
                config?.stardust?.business_unit_identifier ||
                config?.cartConfig?.businessUnitId ||
                config?.cartConfig?.stardust?.business_unit_identifier ||
                ''
        };
    }

    @computed
    public get businessUnitId() {
        return this.config?.businessUnitId || this.config?.stardust?.business_unit_identifier;
    }

    @computed
    public get recommendedConfigs() {
        return this.config.cartConfig?.recommendedConfigs;
    }

    @computed get brandId() {
        return this.config?.perlgem?.brandId || this.config?.perlgem?.brand_id || '22';
    }

    @computed get regionId() {
        return this.config?.perlgem?.regionId || this.config?.perlgem?.region_id || '5';
    }

    @computed
    public get currency() {
        return this.config.currency;
    }

    @computed
    public get currencyFormat() {
        return this.config.currencyFormat;
    }
}
